var tripleSmallSliderInterstellar = {};
tripleSmallSliderInterstellar.slider = function () {
  var smallSlider = $(".js-triple-small-slider");
  if (smallSlider.length === 0) {
    return;
  }
  $.each(smallSlider, function () {
    var $slider = $(this);
    var sliderLength = $slider.find(".js-triple-small-slider-item").length;
    var isDraggable = false;
    var sliderAlign;
    if (matchMedia("screen and (max-width: 991px)").matches) {
      sliderAlign = "center";
      if (sliderLength >= 2) {
        isDraggable = true;
      }
    } else {
      sliderAlign = "left";
      if (sliderLength > 3) {
        isDraggable = true;
      }
    }
    $slider.flickity({
      cellAlign: sliderAlign,
      wrapAround: true,
      prevNextButtons: sliderLength > 3 ? true : false,
      draggable: isDraggable,
      pageDots: sliderLength > 3 ? true : false,
      dragThreshold: 10,
      selectedAttraction: 0.01,
      friction: 0.15,
      on: {
        ready: function ready() {
          $slider.removeClass("invisible");
        }
      }
    });
  });
};
tripleSmallSliderInterstellar.textSlider = function () {
  var smallTextSlider = $(".js-triple-small-slider-text");
  if (smallTextSlider.length === 0) {
    return;
  }
  $.each(smallTextSlider, function () {
    var $slider = $(this);
    var sliderLength = $slider.find(".js-triple-small-slider-text-item").length;
    var isDraggable = false;
    var sliderAlign;
    if (matchMedia("screen and (max-width: 991px)").matches) {
      sliderAlign = "center";
      if (sliderLength >= 2) {
        isDraggable = true;
      }
    } else {
      sliderAlign = "left";
      if (sliderLength > 3) {
        isDraggable = true;
      }
    }
    $slider.flickity({
      cellAlign: sliderAlign,
      wrapAround: true,
      prevNextButtons: sliderLength > 3 ? true : false,
      draggable: isDraggable,
      pageDots: sliderLength > 3 ? true : false,
      dragThreshold: 10,
      selectedAttraction: 0.01,
      friction: 0.15,
      on: {
        ready: function ready() {
          $slider.removeClass("invisible");
          if (sliderLength <= 2) {
            $slider.find(".flickity-slider").addClass("is-centered");
          }
        }
      }
    });
  });
};
tripleSmallSliderInterstellar.slider();
tripleSmallSliderInterstellar.textSlider();
window.tripleSmallSliderInterstellar = tripleSmallSliderInterstellar;


// WEBPACK FOOTER //
// ./scripts/components/sliders/interstellar/triple-small-slider.js